<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des liens Entreprise / Restaurants</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <!-- Alerte pour les notifications - Standardized -->
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>

        <!-- Modal pour ajouter/créer une nouvelle affiliation - Version améliorée -->
        <v-dialog max-width="450px" persistent v-model="dialogAdd">
          <v-card class="affiliation-dialog">
            <!-- En-tête avec titre -->
            <v-toolbar color="#01579B" dark flat>
              <v-toolbar-title class="text-h6 font-weight-medium">Nouvelle affiliation</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="hideAddAffiliation" icon dark>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <!-- Contenu du formulaire avec meilleur positionnement -->
            <v-card-text class="pa-4">
              <v-container class="pa-0">
                <!-- Étape avec meilleure visibilité -->
                <div class="d-flex align-center mb-4">
                  <v-avatar color="#01579B" size="36" class="mr-3">
                    <span class="white--text">1</span>
                  </v-avatar>
                  <span class="text-h6">Informations de l'affiliation</span>
                </div>

                <!-- Select d'entreprise avec meilleure visibilité -->
                <div class="form-field mb-5">
                  <label for="company-select" class="field-label">Entreprise</label>
                  <div class="select-wrapper">
                    <select
                        id="company-select"
                        v-model="newAffiliation.walletCompanyId"
                        class="custom-select"
                    >
                      <option value="" disabled selected>Sélectionner une entreprise</option>
                      <option
                          v-for="company in companies"
                          :key="company.id"
                          :value="company.id"
                      >
                        {{ company.name }}
                      </option>
                    </select>
                    <div class="select-icon">
                      <v-icon color="#01579B">mdi-chevron-down</v-icon>
                    </div>
                  </div>
                  <div v-if="!newAffiliation.walletCompanyId && formSubmitted" class="error-text mt-1">
                    L'entreprise est obligatoire
                  </div>
                </div>

                <!-- Select de restaurant avec meilleure visibilité -->
                <div class="form-field mb-4">
                  <label for="restaurant-select" class="field-label">Restaurant</label>
                  <div class="select-wrapper">
                    <select
                        id="restaurant-select"
                        v-model="newAffiliation.walletRestaurantId"
                        class="custom-select"
                    >
                      <option value="" disabled selected>Sélectionner un restaurant</option>
                      <option
                          v-for="restaurant in restaurants"
                          :key="restaurant.id"
                          :value="restaurant.id"
                      >
                        {{ restaurant.name }}
                      </option>
                    </select>
                    <div class="select-icon">
                      <v-icon color="#01579B">mdi-chevron-down</v-icon>
                    </div>
                  </div>
                  <div v-if="!newAffiliation.walletRestaurantId && formSubmitted" class="error-text mt-1">
                    Le restaurant est obligatoire
                  </div>
                </div>

                <!-- Bouton de validation -->
                <div class="text-center mt-3">
                  <v-btn
                      color="#01579B"
                      width="40"
                      height="40"
                      fab
                      small
                      class="mx-auto"
                      title="Valider les informations"
                  >
                    <v-icon>mdi-check-all</v-icon>
                  </v-btn>
                </div>
              </v-container>
            </v-card-text>

            <!-- Bouton de création clairement visible -->
            <v-card-actions class="pa-4 pt-0">
              <v-spacer></v-spacer>
              <v-btn
                  @click="validateAndCreate"
                  class="white--text create-btn"
                  color="#01579B"
                  depressed
                  large
                  rounded
                  min-width="200"
                  elevation="1"
              >
                <v-icon left>mdi-check</v-icon>
                Créer affiliation
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export affiliations</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="showAddAffiliation" block class="custom-btn white--text" color="#009688" height="45px" large>
                <v-icon class="mr-1">mdi-plus-circle</v-icon>
                <span>Nouvelle affiliation</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mt-4" elevation="6">
          <hot-table
              :settings="hotSettings"
              ref="hotTable"
              @afterSelectionEnd="afterSelectionEnd"
          ></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "lien_entreprise_restaurant",
  components: {HotTable},
  data: function () {
    return {
      formSubmitted: false,
      dialogAdd: false, // Remplacer dialog par dialogAdd
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      selectedRow: null,
      loading: false,
      loading2: false,
      e6: 1,
      tab: null,
      text: "",
      color: "",
      file: "",
      valid: false,
      errors: [],
      excelData: [],
      companyRules: [
        v => !!v || 'L\'entreprise est obligatoire',
      ],
      restaurantRules: [
        v => !!v || 'Le restaurant est obligatoire',
      ],
      companies: [],
      restaurants: [],
      toObject: [],
      newAffiliation: {
        walletCompanyId: null,
        walletRestaurantId: null
      },
      // Standardized alert properties
      type: null,
      elapse: null,
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 3, 4, 5],
          indicators: false
        },
        colHeaders: [
          "Id", "Nom entreprise", "Nom restaurant", "Date création", "Entreprise ID", "Restaurant ID"
        ],
        columns: [
          {title: "Id", width: "10px"},
          {title: "Nom entreprise", width: "100px"},
          {title: "Nom restaurant", width: "100px"},
          {title: "Date de création", width: "100px", align: "center", type: "date"},
          {title: "Entreprise ID", width: "10px"},
          {title: "Restaurant ID", width: "10px"}
        ],
        contextMenu: {
          items: {
            'delete': {
              name: 'Supprimer',
              callback: (key, selection) => {
                this.deleteSelectedRow(selection[0].start.row);
              }
            }
          }
        }
      }
    }
  },
  computed: {
    formIsValid() {
      return this.newAffiliation.walletCompanyId && this.newAffiliation.walletRestaurantId;
    }
  },
  created() {
    this.getData();
    this.loadCompaniesAndRestaurants();
  },
  methods: {
    // Standardized alert methods
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },
    dismissible_close() {
      this.elapse = 3;
      clearTimeout(this.showAlert.timer);
      clearInterval(this.showAlert.t);
      this.type = null;
    },
    validateAndCreate() {
      this.formSubmitted = true;

      // Validation manuelle
      if (!this.newAffiliation.walletCompanyId || !this.newAffiliation.walletRestaurantId) {
        this.text = "Veuillez remplir tous les champs obligatoires";
        this.showAlert('warning');
        return;
      }

      // Tout est valide, procéder avec la création
      this.createLinkCompanyResto();
    },
    loadCompaniesAndRestaurants() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_companies/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            if (response.data.status === 200) {

              // Filtrer les entreprises et restaurants
              this.companies = response.data.datas.filter(company => company.restaurant === false);
              this.restaurants = response.data.datas.filter(company => company.restaurant === true);

            } else {
              this.text = "Erreur lors du chargement des données";
              this.showAlert('warning');
            }
          })
          .catch(error => {
            console.error("Erreur:", error);
            this.text = "Erreur lors du chargement des entreprises et restaurants";
            this.showAlert('warning');
          });
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    afterSelectionEnd(r, c) {
      this.selectedRow = r;

      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    // Standardized confirmation dialog implementation
    deleteSelectedRow(rowIndex) {
      if (rowIndex < 0 || rowIndex >= this.$refs.hotTable.hotInstance.countRows()) {
        return;
      }

      const rowData = this.$refs.hotTable.hotInstance.getDataAtRow(rowIndex);
      const affiliationId = rowData[0];

      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression du lien entre l\'entreprise et le restaurant.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_link_company_restaurant/${affiliationId}/${sessionStorage.getItem("accountId")}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.text = "L'affiliation a été supprimée avec succès";
                    this.showAlert('info');
                    this.getData();
                  } else {
                    this.text = res.data.message || "Erreur lors de la suppression de l'affiliation";
                    this.showAlert('warning');
                  }
                })
                .catch(error => {
                  dialog.close();
                  this.loading = false;
                  console.error("Erreur lors de la suppression:", error);
                  this.text = "Erreur lors de la suppression de l'affiliation";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // User cancelled, no action needed
          });
    },
    showAddAffiliation() {
      // Reset form and data
      this.newAffiliation = {
        walletCompanyId: null,
        walletRestaurantId: null
      };

      this.e6 = 1;
      this.formSubmitted = false;

      // Charger à nouveau les données
      this.loadCompaniesAndRestaurants();

      this.dialogAdd = true;
    },
    hideAddAffiliation() {
      this.dialogAdd = false;
    },
    createLinkCompanyResto() {
      if (!this.formIsValid) {
        this.text = "Veuillez remplir tous les champs obligatoires";
        this.showAlert('warning');
        return;
      }

      this.loading = true;
      this.hideAddAffiliation();

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/wallet/add_wallet_link_company_to_restaurant/` +
              this.newAffiliation.walletCompanyId + "/" +
              this.newAffiliation.walletRestaurantId + "/" +
              sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false;
            if (response.data.status === 200) {
              this.text = "L'affiliation a été créée avec succès";
              this.showAlert('info');
              this.getData();
            } else {
              this.text = response.data.message || "Erreur lors de la création de l'affiliation";
              this.showAlert('warning');
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("Erreur lors de la création:", error);
            this.text = "Erreur lors de la création de l'affiliation";
            this.showAlert('warning');
          });
    },
    getData() {
      this.loading = true;
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_link_company_resto/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false;
            if (response.data.status === 200) {
              let tabArray = [];
              let newObj = response.data.datas;

              newObj.forEach((item) => {
                tabArray.push([
                  item["id"],
                  item["walletCompanyName"] ? item["walletCompanyName"].toUpperCase() : "N/A",
                  item["walletRestaurantName"] ? item["walletRestaurantName"].toUpperCase() : "N/A",
                  this.datefull(item["creationDate"]),
                  item["walletCompanyId"],
                  item["walletRestaurantId"]
                ]);
              });

              this.$refs.hotTable.hotInstance.loadData(tabArray);
              this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
            } else {
              this.text = response.data.message || "Erreur lors du chargement des données";
              this.showAlert('warning');
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("Erreur:", error);
            this.text = "Erreur lors du chargement des données";
            this.showAlert('warning');
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    onCancel() {
      this.loading = false;
    },
    refresh() {
      this.getData();
      this.loadCompaniesAndRestaurants();
    },
    datefull(val) {
      if (!val) {
        return;
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    onexport() { // On Click Excel download button
      this.loading = true;
      // export json to Worksheet of Excel
      var visibleData = this.toObject.map(row => {
        // Filtrer les colonnes cachées (0, 3, 4, 5)
        if (Array.isArray(row)) {
          return [row[1], row[2]]; // Garder uniquement les colonnes visibles
        } else {
          return ["Nom entreprise", "Nom restaurant"]; // En-têtes des colonnes visibles
        }
      });

      var datas = XLSX.utils.json_to_sheet(visibleData, {skipHeader: true});

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      XLSX.utils.book_append_sheet(wb, datas, "LiensEntreprisesRestaurants");

      // export Excel file
      XLSX.writeFile(wb, "LiensEntreprisesRestaurants.xlsx");
      this.loading = false;
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    }
  }
};
</script>

<style scoped>
/* Styles de base */
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.area.highlight,
.htCenter.htMiddle.highlight {
  background-color: #d0e1ef !important;
}

/* Styles spécifiques pour la fenêtre de création d'affiliation */
.affiliation-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.form-field {
  margin-bottom: 20px;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
}

.select-wrapper {
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-select {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}

.custom-select:hover {
  border-color: #01579B;
}

.custom-select:focus {
  outline: none;
  border-color: #01579B;
  box-shadow: 0 0 0 2px rgba(1, 87, 155, 0.2);
}

.select-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  transition: transform 0.2s ease;
}

.select-wrapper:hover .select-icon {
  color: #01579B;
}

.error-text {
  color: #f44336;
  font-size: 12px;
  margin-top: 4px;
}

.create-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.5px;
}

.create-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s ease;
}

.custom-select option[value=""][disabled] {
  color: rgba(0, 0, 0, 0.4);
}

.custom-select option:not([value=""][disabled]) {
  font-weight: 500;
}

.custom-select:invalid {
  color: rgba(0, 0, 0, 0.4);
}
</style>